import CardDetailsCurrentUser from './CardDetailsCurrentUser';
import CardDetails from './CardDetails';

export default CardDetails;
export { CardDetailsCurrentUser };